import {HiOutlineMail} from 'react-icons/hi'
import {BsWhatsapp, BsTwitter} from 'react-icons/bs'
import { useRef, useState } from 'react';

const Contact = () => {
  const form = useRef ()
  const [status, setStatus] = useState(null)
  const [sending, setSending] = useState(false)

  const sendEmail = async (e) => {
    e.preventDefault();
    setStatus(null)
    setSending(true)

    const formData = new FormData(form.current)

    try {
      const res = await fetch('/api/contact', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          name: formData.get('name'),
          email: formData.get('email'),
          message: formData.get('message'),
        }),
      })

      if (!res.ok) throw new Error('Request failed')

      form.current.reset()
      setStatus('success')
    } catch (error) {
      console.error('Failed to send email:', error);
      setStatus('error')
    } finally {
      setSending(false)
    }
  };
  return (
    <section id='contact'>
      <h5>Get in Touch</h5>
      <h2>Contact Me</h2>

      <div className='container !w-[58%] grid grid-cols-[30%_58%] gap-48 max-[1024px]:!grid-cols-1 max-[1024px]:gap-8 max-[600px]:!w-[90%]'>
        <div className='flex flex-col gap-5'>
          <article className='bg-bg-variant p-5 rounded-2xl text-center border border-transparent transition hover:bg-transparent hover:border-primary-variant' >
            <HiOutlineMail className='text-2xl mb-2'/>
            <h4>Email</h4>
            <h5>Tosetony0007@gmail.com</h5>
            <a href='mailto:Tosetony0007@gmail.com' target='_blank' rel='noreferrer' className='mt-3 inline-block text-[0.8rem]'>Send a Message</a>
          </article>
          <article className='bg-bg-variant p-5 rounded-2xl text-center border border-transparent transition hover:bg-transparent hover:border-primary-variant' >
            <BsWhatsapp className='text-2xl mb-2'/>
            <h4>WhatsApp</h4>
            <h5>+2348101070424</h5>
            <a href='https://wa.me/+2348101070424' target='_blank' rel='noreferrer' className='mt-3 inline-block text-[0.8rem]'>Send a Message</a>
         </article>
          <article className='bg-bg-variant p-5 rounded-2xl text-center border border-transparent transition hover:bg-transparent hover:border-primary-variant' >
            <BsTwitter className='text-2xl mb-2'/>
            <h4>Twitter</h4>
            <h5>Tonylyon7</h5>
            <a href='https://twitter.com/Tonylyon7' target='_blank' rel='noreferrer' className='mt-3 inline-block text-[0.8rem]'>Send a Message</a>
         </article>
        </div>
        <form ref={form} onSubmit={sendEmail} className='flex flex-col gap-5'>
          <input type='text' name='name' placeholder='Your full name' required className='w-full p-6 rounded-lg bg-bg-variant border-2 border-primary/40 text-white placeholder-light outline-none transition focus:border-primary'/>
          <input type='email' name='email' placeholder='Your Email' required className='w-full p-6 rounded-lg bg-bg-variant border-2 border-primary/40 text-white placeholder-light outline-none transition focus:border-primary'/>
          <textarea name='message' rows='7' placeholder='Your Message' required className='w-full p-6 rounded-lg bg-bg-variant border-2 border-primary/40 text-white placeholder-light outline-none transition resize-none focus:border-primary'></textarea>
          <button type='submit' className='btn btn-primary' disabled={sending}>{sending ? 'Sending...' : 'Send message'}</button>
          {status === 'success' && <p className='text-primary text-center'>Message sent successfully!</p>}
          {status === 'error' && <p className='text-center text-red-500'>Something went wrong. Please try again or email me directly.</p>}
        </form>
      </div>
    </section>
  )
}

export default Contact
